import React, { useRef } from 'react';
import { ArrowIcon } from '../../../../components/ArrowIcon/index.js';

var User = function User(props) {
  var uname = props.uname,
    menus = props.menus;
  var menuRef = useRef(null);
  var handleMouseEnter = function handleMouseEnter() {
    var menuDom = menuRef.current;
    menuDom.classList.add('hover-cls');
  };
  var handleMouseLeave = function handleMouseLeave() {
    var menuDom = menuRef.current;
    menuDom.classList.remove('hover-cls');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "header-user",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement("div", {
    className: "user-menu-root"
  }, /*#__PURE__*/React.createElement("span", {
    className: "user-name-logo"
  }, uname === null || uname === void 0 ? void 0 : uname.slice(0, 1)), /*#__PURE__*/React.createElement("span", {
    className: "user-name"
  }, uname), /*#__PURE__*/React.createElement(ArrowIcon, null), /*#__PURE__*/React.createElement("div", {
    ref: menuRef,
    className: "user-menu-popover"
  }, /*#__PURE__*/React.createElement("div", {
    className: "user-menu-popover-box"
  }, menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
    var title = item.title,
      link = item.link,
      _a = item.target,
      target = _a === void 0 ? '_self' : _a;
    return /*#__PURE__*/React.createElement("a", {
      key: title + index,
      className: "user-menu-popover-item",
      href: link,
      target: target,
      rel: "noopener noreferrer",
      "data-track-name": "\u6309\u94AE\u70B9\u51FB",
      "data-track-value": title,
      "data-track-category": "\u5934\u90E8\u5BFC\u822A"
    }, title);
  })))));
};

export { User as default };
